export default {
  namespaced: true,

  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      if (parentModule === 'topSectionModule' || parentModule === 'bottomSectionModule') {
        let sections = rootGetters['layoutComponentModule/elements'](element, parentModule).sections
        return Object.prototype.hasOwnProperty.call(element, 'componentSection') ? sections[element.componentSection] : sections  
      }
      if (element.layoutPageComponent !== undefined && element.layoutPageComponent !== null) {
        let sections = rootGetters['layoutPageComponentModule/elements'](element).sections
        return Object.prototype.hasOwnProperty.call(element, 'componentSection') ? sections[element.componentSection] : sections
      }
      if (element.pageComponent !== undefined && element.pageComponent !== null) {
        let sections = rootGetters['pageComponentModule/elements'](element).sections
        return Object.prototype.hasOwnProperty.call(element, 'componentSection') ? sections[element.componentSection] : sections
      }
      let sections = rootGetters['componentModule/elements'](element).sections
      return Object.prototype.hasOwnProperty.call(element, 'componentSection') ? sections[element.componentSection] : sections
    },
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(component => component.id == id),
    id: (state, getters) => (element, id = 'id', parentModule) => getters.elements(element, parentModule)[id],
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
  },

  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'componentSectionModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'componentSectionModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'componentSectionModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'componentSectionModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}